import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';

import { resetAIVoiceModal } from 'js/src/data/ai-voices-and-avatars/ai-voice-modal/ai-voice-modal-slice';
import type { VoiceCloningModalContext, VoiceSelectionModalContext } from 'js/src/data/modals';
import { getModalContext, hideModal, MODAL_IDS, showModal } from 'js/src/data/modals';
import { ImmutableFromJS } from 'js/src/libs/consts';
import { useAppDispatch } from 'js/src/libs/RootState';

type AIVoiceAddYourOwnRowProps = {
    className?: string;
    style: React.CSSProperties;
};

const AIVoiceAddYourOwnRow: React.FC<AIVoiceAddYourOwnRowProps> = ({ className, style }) => {
    const dispatch = useAppDispatch();
    const voiceSelectionContext = useSelector(
        getModalContext<VoiceSelectionModalContext>,
    )?.toJS() as VoiceSelectionModalContext | undefined;

    const handleClick = useCallback(() => {
        dispatch(hideModal());
        dispatch(resetAIVoiceModal());
        dispatch(
            showModal({
                modal_id: MODAL_IDS.VOICE_CLONING,
                modal_context: ImmutableFromJS({
                    returnToVoiceSelection: voiceSelectionContext,
                }) as ReturnType<typeof ImmutableFromJS<VoiceCloningModalContext>>,
            }),
        );
    }, [dispatch, voiceSelectionContext]);

    return (
        <div
            className={classnames('row cursor-pointer', className)}
            style={style}
            role="button"
            tabIndex={0}
            onClick={handleClick}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleClick();
                }
            }}
            data-testid="ai-voice-add-your-own-row"
        >
            <div className="col font-l5 font-l5--small--semibold color-primary text-decoration-underline">
                + Add your own AI voice
            </div>
        </div>
    );
};

export default AIVoiceAddYourOwnRow;
